import { JSX, render }	from "preact";
import { useState }		from "preact/hooks";

import { Endo }			from "ts-base/endo";

import { UseState }		from "@v3/preact/hook/types";

/** call to update the top-level model */
export type Refresh<T> = (change:Endo<T>) => void;

export namespace Refresh {
	export type Props<T> = {
		// where to install the root component into
		container:	Element|Document,
		// initial model state
		initial:	T,
		// the root component to install, gets passed the model and a ways to update the model
		component:	(...model:UseState<T>) => JSX.Element,
	};

	/** install a component in the dom and provide a way to refresh its model */
	export const install	= <T,>({ container, initial, component }:Props<T>):Refresh<T> => {
		let refresh:Refresh<T>|null	= null;

		const Root	= ():JSX.Element	=> {
			const [ model, setModel ]	= useState(initial);
			refresh	= setModel;
			return component(model, setModel);
		};

		render(<Root/>, container);

		return refresh!;
	};

	/** a dummy refresh which can be used before install has been called */
	export const notInstalled	= <T,>():Refresh<T>	=>
		() => {
			// eslint-disable-next-line no-console
			console.error("cannot refresh before the root component is installed");
		};
}
